import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import marketMap from "../assets/lottie-files/marketMap.lottie";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" as const },
  },
};
const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
};

const MarketMapFromWP = () => {
  const [loading, setLoading] = useState(true);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const containerId = "market-map-embed-container";

    const container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = "";

    // Remove old script if it exists (important)
    const oldScript = document.querySelector(
      'script[src="https://app.marketwurks.com/assets/embed.js"]',
    );
    if (oldScript) {
      oldScript.remove();
    }

    const script = document.createElement("script");
    script.src = "https://app.marketwurks.com/assets/embed.js";
    script.async = true;

    script.setAttribute(
      "data-resource-id",
      "markets/ba71b3f11ef9ca2fa42b987c5425d5dc",
    );
    script.setAttribute("data-org-id", "2059e9ddd0a241ff86ccb7d0189dbe64");

    script.onload = () => {
      setLoading(false);
      setFadeIn(true);
    };

    // 🔑 CRITICAL: append script NEXT TO container, not body
    container.appendChild(script);
  }, []);

  return (
    <>
      <section
        style={{
          background:
            "linear-gradient(135deg, #0a2605 0%, #0d1b2a 55%, #150308 100%)",
          padding: "5rem 1.5rem 6rem",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -120,
            right: -120,
            width: 440,
            height: 440,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(198,37,45,0.2) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -100,
            left: -100,
            width: 380,
            height: 380,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(109,199,68,0.15) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "3rem",
            position: "relative",
            zIndex: 1,
          }}
        >
          <motion.div
            style={{ flex: "1 1 480px", minWidth: 300 }}
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            <motion.span
              variants={fadeUp}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: "rgba(109,199,68,0.12)",
                border: "1px solid rgba(109,199,68,0.3)",
                borderRadius: 999,
                padding: "0.35rem 1rem",
                color: "#6dc744",
                fontSize: "0.82rem",
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                marginBottom: "1rem",
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  background: "#6dc744",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              />
              Interactive Map
            </motion.span>

            <motion.h1
              variants={fadeUp}
              style={{
                fontSize: "clamp(2.4rem, 5.5vw, 4rem)",
                fontWeight: 900,
                color: "white",
                lineHeight: 1.08,
                marginBottom: "1.25rem",
              }}
            >
              Market{" "}
              <span
                style={{
                  background: "linear-gradient(90deg, #6dc744, #c6252d)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Site Map
              </span>
            </motion.h1>

            <motion.p
              variants={fadeUp}
              style={{
                fontSize: "1.15rem",
                color: "rgba(255,255,255,0.72)",
                lineHeight: 1.7,
                maxWidth: 520,
              }}
            >
              View our full vendor layout and locations across the market. Find
              your favourite stalls and plan your visit.
            </motion.p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.88 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.85, ease: "easeOut" }}
            style={{
              flex: "1 1 360px",
              minWidth: 280,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <DotLottieReact
              src={marketMap}
              autoplay
              loop
              style={{ width: "100%", maxWidth: 440 }}
            />
          </motion.div>
        </div>
      </section>
      <div
        style={{
          background: "#fff",
          padding: "2.5rem 1rem",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "2rem 0",
          }}
        >
          {loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "1rem",
                fontSize: "1rem",
                color: "#D46540",
              }}
            >
              Loading map...
            </div>
          )}

          <div
            id="market-map-embed-container"
            style={{
              background: "#f8f8f8",
              borderRadius: "1rem",
              padding: "2rem",
              minHeight: "300px",
              boxShadow: "0 2px 12px rgba(212,101,64,0.07)",
              opacity: fadeIn ? 1 : 0,
              transition: "opacity .6s ease-in-out",
            }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default MarketMapFromWP;
